import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import Input from './Input';
import Select from './Select';

export function FilterControls({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filters = [],
  className = ''
}) {
  return (
    <div className={`flex flex-col sm:flex-row gap-3 mb-4 ${className}`}>
      <div className="flex-1">
        <div className="relative">
          <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-text-secondary-light dark:text-text-secondary" />
          <Input
            type="text"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            className="pl-10 w-full"
          />
        </div>
      </div>
      {filters.map((filter, index) => (
        <div key={index} className="sm:w-48">
          <Select
            value={filter.value}
            onChange={(e) => filter.onChange(e.target.value)}
            className="w-full"
          >
            <option value="">
              {filter.placeholder || `All ${filter.label}`}
            </option>
            {filter.options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      ))}
    </div>
  );
}
